
    import './webpack-public-path.js';
    import { createClient } from '@wkda/funnel-builder/client/createClient.js';
    import { buildRoutes } from '@wkda/funnel-builder/shared/buildRoutes.js';
    import { activate, initializeI18n } from '@wkda/funnel-builder/internationalization/index.js';
    import config from './src/configuration/index.js';
    import routes from './src/routes.js';

    initializeI18n(config.locale);

    /*
     *Entry point for the client application
     */
    createClient({
      config,
      routes: buildRoutes(routes, config),
      activateLocale: activate,
    });
  